import React from 'react';
import ActionGroup from '../ActionGroup';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Permission } from "../../../components/SessionInfo";

export default function ListActions({addTitle, refreshTitle, onAddClick, isRefreshing, onRefreshClick, permission, pageSizes, pageSize, onPageSizeChange }) {
  return (
    <ActionGroup>
        {
            pageSizes instanceof Array
                ? pageSizes.map(size => <Button
                    title={`Отображать ${size} записей`}
                    style={{ minWidth: '35px' }}
                    variant="contained"
                    key={`s-${size}`}
                    color={size===pageSize? 'info': 'primary'}
                    onClick={onPageSizeChange.bind(null, size)}>
                        {size}
                    </Button>)
                : ''
        }
        { pageSizes instanceof Array && pageSizes.length >0 ? <span>&nbsp;&nbsp;</span> : '' }
        {
            permission === Permission.WRITE && addTitle
                ? <Button title={addTitle ?? 'Добавить'} variant="contained" color="primary" onClick={onAddClick}><AddIcon /></Button>
                : ''
        }
      <Button
        variant="contained"
        color="primary"
        title={refreshTitle ?? 'Обновить'}
        disabled={isRefreshing}
        onClick={onRefreshClick}
      >
        <RefreshIcon/>
      </Button>
    </ActionGroup>
  );
}
